import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ChatbotEmbed from '../views/embed-views/ChatbotEmbed';
import VideoEmbed from '../views/embed-views/VideoEmbed';

const EmbedRoute = () => {
  return (
    <Routes>
      <Route path="/chat" element={<ChatbotEmbed />} />
      <Route path="/chat/:agentId" element={<ChatbotEmbed />} />
      <Route path="/chat/:agentId/:sessionId" element={<ChatbotEmbed />} />
      <Route path="/video" element={<VideoEmbed />} />
      {/* Default route redirects to chat */}
      <Route path="/" element={<ChatbotEmbed />} />
    </Routes>
  );
};

export default EmbedRoute;
